import { useContext } from 'react';
import { PropertyContext } from '../context/PropertyContext';
export const usePropertyDefinition = () => useContext(PropertyContext).property;